import { HttpClient } from "./httpClient"
import * as ApiEvents from './apiEvents'


export const createNote = (payload) =>{

    const data = {
        "eventMessage":{
           ...payload
        },
        "eventType":ApiEvents.SAVE_SHIPMENT_NOTES,
        "eventTime":Date.now()
      }
    
      return HttpClient.custom({
        data
      })

}


export const getNotesList = (shipmentId)=>{
    const data = {
        "eventMessage":{
           shipmentId
        },
        "eventType":ApiEvents.GET_SHIPMENT_NOTES,
        "eventTime":Date.now()
      }
    
      return HttpClient.custom({
        data
      })
}